import React, { createContext, PropsWithChildren } from "react";
import { useViewport } from "../utils/viewportHook";

export type MapZoomContextType = Pick<
  ReturnType<typeof useViewport>,
  "zoomToPoint" | "zoomToBounds"
>;

const noop = async () => {};

export const MapZoomContext = createContext<MapZoomContextType>({
  zoomToPoint: noop,
  zoomToBounds: noop,
});

export const MapZoomProvider = ({
  zoomToPoint,
  zoomToBounds,
  children,
}: PropsWithChildren<MapZoomContextType>) => {
  return (
    <MapZoomContext.Provider value={{ zoomToPoint, zoomToBounds }}>
      {children}
    </MapZoomContext.Provider>
  );
};
